import { MEMBERS_DETAILS_SCREEN_TITLE, MEMBERS_SCREEN_TITLE, USER_ACTION_CARD_RIGHT_NAVIGATION, USER_ACTION_LOCATION_DEFAULT, USER_ACTION_MODULE_MEMBER_DETAIL, USER_ACTION_MODULE_MEMBER_LIST, USER_ACTION_TAB_GLOBAL } from "@utils/constants";

export const timeInterval = [
  "09:00 am",
  "09:15 am",
  "09:30 am",
  "09:45 am",
  "10:00 am",
  "10:15 am",
  "10:30 am",
  "10:45 am",
  "11:00 am",
  "11:15 am",
  "11:30 am",
  "11:45 am",
  "12:00 pm",
  "12:15 pm",
  "12:30 pm",
  "12:45 pm",
  "01:00 pm",
  "01:15 pm",
  "01:30 pm",
  "01:45 pm",
  "02:00 pm",
  "02:15 pm",
  "02:30 pm",
  "02:45 pm",
  "03:00 pm",
  "03:15 pm",
  "03:30 pm",
  "03:45 pm",
  "04:00 pm",
  "04:15 pm",
  "04:30 pm",
  "04:45 pm",
  "05:00 pm",
  "05:15 pm",
  "05:30 pm",
  "05:45 pm",
  "06:00 pm",
];

export const DAY = 'Day';

export const WEEK = 'Week';

export const MONTH = 'Month';

export const REMINDER_VIEW_TYPES = [DAY , WEEK , MONTH];

// Paginated Upcoming reminder constants
export const lazyLoadingRemindersLimit = 5;
export const reminderStatsForPastLimit = 30;
export const currentAndUpcomingReminderDOM_Height = 200;

export const getUserActionParams = (userActionDescription: any, reason: any , currentScreen : string) => {
  let props;
  switch (currentScreen) {
    case MEMBERS_SCREEN_TITLE:
      props = {
        caseStatusReasonTxt: reason,
        actionModule: USER_ACTION_MODULE_MEMBER_LIST,
        actionTab: USER_ACTION_TAB_GLOBAL,
        actionCard: USER_ACTION_CARD_RIGHT_NAVIGATION,
        actionLocation: USER_ACTION_LOCATION_DEFAULT,
        actionDescription: userActionDescription,
      };
      break;
    case MEMBERS_DETAILS_SCREEN_TITLE:
      props = {
        caseStatusReasonTxt: reason,
        actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
        actionTab: USER_ACTION_TAB_GLOBAL,
        actionCard: USER_ACTION_CARD_RIGHT_NAVIGATION,
        actionLocation: USER_ACTION_LOCATION_DEFAULT,
        actionDescription: userActionDescription,
      };
      break;
    default:
      props = {};
  }
  return props;
};
